<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <SidebarToggler class="d-md-down-none" display="lg"/>
      <b-navbar-nav class="ml-auto">
        <UserSettingsDropdown/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <div class="d-flex justify-content-between p-2">
          <SystemTime />
          <SidebarMinimizer />
        </div>
      </AppSidebar>
      <main class="main d-flex flex-column">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import nav from '@/_nav'
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav
} from '@coreui/vue'
import UserSettingsDropdown from '../components/UserSettingsDropdown'
import SystemTime from '../components/SystemTime'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader,
    AppSidebar,
    UserSettingsDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    SystemTime
  },
  data () {
    return {
      nav: nav.items
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/DefaultLayout.vue